module.exports = __webpack_public_path__ + "media/images/proof_links/stumbleupon-ae38ad0adc797f90f4d030eefdbd3420.svg";